import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { usePropertyInfo } from '../../../hooks/usePropertyInfo';
import { Inputs } from '../../../../../../react-commons/utils/form/inputs';
import * as React from 'react';
import { Form_ColorInputProps } from '../../../../../../react-commons/components/form/inputs/Form_ColorInput';

export const From_PropertyColorPicker = <T extends object, N extends boolean>({
    readOnly,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    ...props
}: Omit<Form_ColorInputProps<T, N>, 'label' | 'labelInfo' | 'severity' | 'helperText' | 'endingIcon'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return <Inputs.Color
        {...propertyInfo}
        {...props}
        helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
    />;
};
